import { getFirstDefined } from '../../../util';
import { getMarkConfig } from '../../common';
const ALIGNED_X_CHANNEL = {
    left: 'x',
    center: 'xc',
    right: 'x2'
};
const BASELINED_Y_CHANNEL = {
    top: 'y',
    middle: 'yc',
    bottom: 'y2'
};
export function alignedPositionChannel(channel, markDef, config) {
    const alignChannel = channel === 'x' ? 'align' : 'baseline';
    const align = getFirstDefined(markDef[alignChannel], getMarkConfig(alignChannel, markDef, config));
    if (channel === 'x') {
        return ALIGNED_X_CHANNEL[(align !== null && align !== void 0 ? align : 'center')];
    }
    else {
        return BASELINED_Y_CHANNEL[(align !== null && align !== void 0 ? align : 'middle')];
    }
}
//# sourceMappingURL=position-align.js.map